import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { AlertService } from '../../shared/components/alert/alert.service';
import { isApiRequest, SUPPRESS_UNMAPPED_API_ERROR_ALERT } from '../../shared/helpers/api-request-context.helper';
import { isObject } from '../../shared/helpers/get-typeof.helper';
import isEmpty from '../../shared/helpers/is-empty.helper';

const UNMAPPED_API_ERROR_TITLE = 'SHARED.COMMON.ERROR_UNEXPECTED_TITLE';
const UNMAPPED_API_ERROR_DESCRIPTION = 'SHARED.COMMON.ERROR_UNEXPECTED_DESCRIPTION';

type BackendErrorResponse = {
  error: string;
  message: string;
};

const isBackendErrorResponse = (value: unknown): value is BackendErrorResponse =>
  isObject(value) && 'error' in value && 'message' in value;

const getAlertContent = (errorResponse: HttpErrorResponse) => {
  let alertContent = { title: UNMAPPED_API_ERROR_TITLE, description: UNMAPPED_API_ERROR_DESCRIPTION };
  if (isBackendErrorResponse(errorResponse.error)) {
    const apiError = errorResponse.error;
    alertContent = {
      title: isEmpty(apiError.error) ? UNMAPPED_API_ERROR_TITLE : apiError.error,
      description: isEmpty(apiError.message) ? UNMAPPED_API_ERROR_DESCRIPTION : apiError.message,
    };
  }
  return alertContent;
};

export const unmappedApiErrorAlertInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isApiRequest(request) || request.context.get(SUPPRESS_UNMAPPED_API_ERROR_ALERT)) {
    return next(request);
  }

  const alertService = inject(AlertService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const alertContent = getAlertContent(error);
        alertService.error(alertContent.title, alertContent.description, { duration: 5000 });
      }

      return throwError(() => error);
    }),
  );
};
